<template>
  <div class="body">
      <Headtow></Headtow>
      <div  id="bj">
        <div id="w-center">
          <div id="Breadcrumb">
            <i class="el-icon-house Breadcrumb-i" ></i>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>会员中心</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <!-- 左侧 -->
          <Memberleft></Memberleft>

          <!-- 左侧结束 -->
          <div class="w-products rihgt">
            <div class="Member-right">
                <p class="content-jj">企业信息</p>
            </div>
            <div class="h-20"></div>
            <div class="w-products rihgt Member-right">
              <div class="member-label DeviceInfos">
                <el-tabs>
                  <el-tab-pane label="企业信息">
                    <el-form ref="form" :model="form" label-width="100px" v-loading="loading">
                      <el-form-item label="企业名称：">
                        <el-input placeholder="请输入企业名称" v-model="form.title"></el-input>
                      </el-form-item>
                      <el-form-item label="企业logo：" >
                          <el-upload
                            class="avatar-uploader avatar-uploader-left"
                            action="http://pc.zyjlfwpt.com/api.php/Upload/uploadcords"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload">
                            <img v-if="imageLogo" :src="imageLogo" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            <div slot="tip" class="el-upload__tip el-upload__tip-img">建议尺寸330*75、只能是JPG、png、JEpg格式且不超过2M</div>
                          </el-upload>
                      </el-form-item>
                      <el-form-item label="企业形象：" >
                          <el-upload
                            class="avatar-uploader avatar-uploader-left"
                            action="http://pc.zyjlfwpt.com/api.php/Upload/uploadcords"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess_s"
                            :before-upload="beforeAvatarUpload_s">
                            <img v-if="imageBanner" :src="imageBanner" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            <div slot="tip" class="el-upload__tip el-upload__tip-img">建议尺寸1920*400、只能是JPG、png、JEpg格式且不超过2M</div>
                          </el-upload>
                      </el-form-item>
                      <el-form-item label="营业执照：" >
                          <el-upload
                            class="avatar-uploader avatar-uploader-left"
                            action="http://pc.zyjlfwpt.com/api.php/Upload/uploadcords"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess_yyzz"
                            :before-upload="beforeAvatarUpload_yyzz">
                            <img v-if="imageYyzz" :src="imageYyzz" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                          </el-upload>
                      </el-form-item>

                      <el-form-item label="联系人：">
                        <el-input placeholder="请输入联系人" v-model="form.lxname"></el-input>
                      </el-form-item>
                      <el-form-item label="客服电话：">
                        <el-input placeholder="请输入客服电话" v-model="form.kftel"></el-input>
                      </el-form-item>
                      <el-form-item label="传 真：">
                        <el-input placeholder="请输入传 真" v-model="form.cz"></el-input>
                      </el-form-item>
                      <el-form-item label="地 址：">
                        <el-input placeholder="请输入地 址" v-model="form.address"></el-input>
                      </el-form-item>
                      <el-form-item label="邮 编：">
                        <el-input placeholder="请输入邮 编" v-model="form.emaile"></el-input>
                      </el-form-item>
                      <el-form-item label="网 站：">
                        <el-input placeholder="请输入网 站" v-model="form.url"></el-input>
                      </el-form-item>
                      <el-form-item label="所在地区：">
                        <el-input placeholder="请输入所在地区" v-model="form.addressdq"></el-input>
                      </el-form-item>
                      <el-form-item label="主营行业：">
                        <el-input placeholder="请输入主营行业" v-model="form.zyhy"></el-input>
                      </el-form-item>
                      <el-form-item label="公司简介：" >
                        <el-input
                          class="textarea-ipt"
                          type="textarea"
                          :autosize="{ minRows: 2, maxRows: 6}"
                          placeholder="请填写公司简介"
                          v-model="form.content">
                        </el-input>
                      </el-form-item>
                      <el-form-item label="备注:">
                          如若以上信息没有请填写无
                      </el-form-item>
                      <el-form-item>
                        <el-button type="primary" @click="onSubmit(form)" size="medium">提交</el-button>
                      </el-form-item>
                    </el-form>
                  </el-tab-pane>
                </el-tabs>
              </div>
              <div class="h-30"></div>

              <div class="h-30 clear"></div>
              <div class="h-30"></div>
            </div>

          </div>

          <div class="clear"></div>


        </div>
      </div>
       <Foot></Foot>
  </div>

</template>

<script>
import headtow from '@/components/public/headtow.vue';
import foot from '@/components/public/foot.vue';
import memberleft from '@/components/public/memberleft.vue'
export default{
  data(){
    return {
      loading:true,
      activeIndex: '3',
      imageLogo: '',
      imageBanner: '',
      imageYyzz:'',
      form: {
        lxname:'',
        title:'',
        content:'',
        kftel:'',
        cz:'',
        address:'',
        emaile:'',
        url:'',
        addressdq:'',
        zyhy:'',
     },
    }
  },
  components: {
    'Headtow': headtow,  //将别名demo 变成 组件 Demo
    'Foot': foot,
    'Memberleft': memberleft,

  },

  mounted () {
    this.recordapi();
  },
  methods:{

    recordapi(){
        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        that.$api.post("/Member/MemberEnterprise",{'userid':userid}).then(res => {
          console.log(res);
          if(res.form != null){
            that.form= res.form;
            if(res.form.imageLogos !== '' || res.form.imageBanners !== '' || res.form.imageYyzzs !== ''){
              this.imageLogo = res.form.imageLogos;
              this.imageBanner = res.form.imageBanners;
              this.imageYyzz = res.form.imageYyzzs;
            }
          }
         this.loading = false
        });
    },


  handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    handleAvatarSuccess(res, file) {
      this.imageLogo = URL.createObjectURL(file.raw);
      this.form.imageLogos = res.path;
    },
    handleAvatarSuccess_s(res, file) {
      this.imageBanner = URL.createObjectURL(file.raw);
      this.form.imageBanners = res.path;
    },
    handleAvatarSuccess_yyzz(res, file) {
      console.log(res)
      this.imageYyzz = URL.createObjectURL(file.raw);
      this.form.imageYyzzs = res.path;
    },
    beforeAvatarUpload(file) {
          const isPNG = file.type === 'image/png/jpeg/jpeg';

        // const isPNG = file.type = ['image/jpeg', 'image/jpg', 'image/png'];
        const isLt2M = file.size / 1024 / 1024 < 2;
        // if(!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
        //   this.$message.error('上传图片只能是 PNG 格式!');
        // }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!');
        }
        return isLt2M;
    },
    beforeAvatarUpload_s(file) {
         const isJPG = file.type === 'image/jpeg';
        // const isJPG = file.type = ['image/jpeg', 'image/jpg', 'image/png'];
        const isLt2M = file.size / 1024 / 1024 < 2;

        // if(!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
        //   this.$message.error('上传头像图片只能是 JPG 格式!');
        // }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!');
        }
        return isLt2M;
    },
    beforeAvatarUpload_yyzz(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!');
        }
        return isLt2M;
    },


    onSubmit(form) {
      var that = this;
      // console.log(form)

      var userid = that.$cookieStore.getCookie('userid');
      that.form.userid = userid;
      console.log(this.form);
      that.$api.post("/Member/MemberEnterpriseAdd",{data:this.form}).then(res => {
        console.log(res);
        this.$message.success(res.msg);
      });
    }

  }

 }
</script>



// WEBPACK FOOTER //
// src/components/MemberEnterprise.vue